import { render, staticRenderFns } from "./FormNewPixel.vue?vue&type=template&id=3ec57311&"
import script from "./FormNewPixel.vue?vue&type=script&lang=js&"
export * from "./FormNewPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports